// export const BASE_URL = 'http://72.167.37.148:9191/api/v1'; //staging 
export const BASE_URL = 'https://bookb.the-algo.com/api/v1'; //production
export const BASE_SOCKET_URL = 'https://bookb.the-algo.com';
export const stripePublicKey = 'pk_live_ijQEYHuZLIsFjwukDmAkn3Hb00GyT5mUjL'
